export class MothershipData {
  id: string;
  entry: string;
  constructor(json: any) {
    this.id = json.id;
    this.entry = json.entry;
  }
}
